<template>
  <div
    class="form-group"
    :class="{
      // 'input-group-focus': focused,
      'has-label': label,
      // 'has-icon': hasIcon,
      'is-disabled': $attrs.disabled,
    }"
  >
    <slot name="label">
      <label v-if="label">
        {{ label }} <span class="required-sign">{{ required ? '*' : '' }}</span>
      </label>
    </slot>
    <div class="mb-0">
      <slot name="addonLeft">
        <span v-if="addonLeftIcon" class="input-group-prepend">
          <div class="input-group-text"><i :class="addonLeftIcon"></i></div>
        </span>
      </slot>
      <slot>
        <input
          :value="modelValue"
          v-bind="$attrs"
          @input="onChanged"
          @blur="onBlur"
          class="form-control"
          aria-describedby="addon-right addon-left"
          :type="type"
        />
      </slot>
      <slot name="addonRight">
        <span v-if="addonRightIcon" class="input-group-append">
          <div class="input-group-text"><i :class="addonRightIcon"></i></div>
        </span>
      </slot>
    </div>

    <slot name="error" v-if="error || $slots.error">
      <label class="error">{{ error }}</label>
    </slot>
    <slot name="helperText"></slot>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'InputText',

  emits: ['update:modelValue', 'blur'],

  props: {
    required: Boolean,
    label: {
      type: String,
      description: 'Input label',
    },
    error: {
      type: String,
      description: 'Input error',
      default: '',
    },
    value: {
      type: [String, Number],
      description: 'Input value',
    },
    addonRightIcon: {
      type: String,
      description: 'Input icon on the right',
    },
    addonLeftIcon: {
      type: String,
      description: 'Input icon on the left',
    },
    type: {
      type: String,
      description: 'Type of the input',
    },
    modelValue: {
      type: [String, Number],
    },
    placeholder: {
      type: String,
      default: '',
    },
    additionalClass: {
      type: String,
      default: '',
    },
  },

  setup(props, { emit }) {
    function onChanged(e) {
      emit('update:modelValue', e.currentTarget.value);
    }

    function onBlur() {
      emit('blur');
    }

    return {
      onChanged,
      onBlur,
    };
  },
});
// export default {
//   inheritAttrs: false,
//   name: 'base-input',
//   props: {
//     required: Boolean,
//     label: {
//       type: String,
//       description: 'Input label'
//     },
//     error: {
//       type: String,
//       description: 'Input error',
//       default: ''
//     },
//     value: {
//       type: [String, Number],
//       description: 'Input value'
//     },
//     addonRightIcon: {
//       type: String,
//       description: 'Input icon on the right'
//     },
//     addonLeftIcon: {
//       type: String,
//       description: 'Input icon on the left'
//     },
//     type:{
//       type:String,
//       description: 'Type of the input'
//     }
//   },
//   model: {
//     prop: 'value',
//     event: 'input'
//   },
//   data() {
//     return {
//       focused: false,
//       touched: false
//     };
//   },
//   computed: {
//     hasIcon() {
//       return this.hasLeftAddon || this.hasRightAddon
//     },
//     hasLeftAddon() {
//       const { addonLeft } = this.$slots;
//       return (
//         addonLeft !== undefined ||
//         this.addonLeftIcon !== undefined
//       );
//     },
//     hasRightAddon() {
//       const { addonRight } = this.$slots;
//       return (
//         addonRight !== undefined ||
//         this.addonRightIcon !== undefined
//       );
//     },
//     listeners() {
//       return {
//         ...this.$listeners,
//         input: this.onInput,
//         blur: this.onBlur,
//         focus: this.onFocus
//       };
//     }
//   },
//   methods: {
//     onInput(evt) {
//       if (!this.touched) {
//         this.touched = true;
//       }
//       console.log(evt.target.value);
//       this.$emit('input', evt.target.value);
//     },
//     onFocus(evt) {
//       this.focused = true;
//       this.$emit('focus', evt)
//     },
//     onBlur(evt) {
//       this.focused = false;
//       this.$emit('blur', evt)
//     }
//   }
// };
</script>
<style>
.base-input .el-input.el-date-editor--date {
  border: 0;
}
.base-input .el-input.el-date-editor--date .el-input__inner {
  height: 36px;
}
.base-input .el-input.is-disabled .el-input__wrapper,
.base-input .el-date-editor--daterange.is-disabled {
  box-shadow: 0 0 0 1px #e3e3e3 inset !important;
  background-color: #f5f5f5;
}
.base-input.form-control:disabled {
  border: 1px solid #e3e3e3;
  background-color: #f5f5f5;
  color: #9e9791;
}
</style>
